import { Link } from "react-router-dom";
import { assets } from "../lib/assets";
import { useAppStore } from "../store/useAppStore";

const mainline = [
  { id: "day1", title: "能量早餐探索", desc: "陪露米找回能量，听一听、找一找、做一个选择。", href: "/journey/day1", chips: ["英语", "观察", "自主选择"] },
  { id: "day2", title: "魔法奶昔实验室", desc: "选择三种食材，观察它们怎样变成香香的奶昔。", href: "/journey/day2", chips: ["英语", "数感", "实验"] },
  { id: "mission3", title: "花园为什么没精神", desc: "用星光镜寻找证据，照顾真正需要水和阳光的植物。", href: "/journey/mission3", chips: ["观察", "英语", "责任感"] }
];

export function HomePage() {
  const { childName, completedTaskIds } = useAppStore();
  const next = mainline.find((task) => !completedTaskIds.some((id) => id.startsWith(task.id)));
  const current = next ?? mainline[mainline.length - 1];
  const completed = mainline.filter((task) => completedTaskIds.some((id) => id.startsWith(task.id))).length;

  return (
    <section className="home-page page-view">
      <div className="home-welcome"><p>晚上好，{childName}</p><h1>今天，<br />去哪里发现新星光？</h1><span>每一次好奇，都会让鹿屿森空更明亮。</span></div>
      <article className="mission-card">
        <span className="mission-kicker">✦ 星光旅程 · 主线任务</span>
        <h2>{next ? current.title : "今天的星光任务完成啦"}</h2>
        <p>{next ? current.desc : "露米已经把今天的发现收好，期待下一次和你相遇。"}</p>
        <div className="mission-tags">{current.chips.map((chip) => <i key={chip}>{chip}</i>)}</div>
        {next ? <Link className="mission-start" to={current.href}>出发吧　→</Link> : <span className="mission-finished">全部完成 ✦</span>}
        <Link className="mission-history" to="/history">任务档案　⌁</Link>
        <div className="mission-progress">{mainline.map((task, index) => <span key={task.id} className={index < completed ? "done" : index === completed ? "current" : ""}>{index + 1}</span>)}</div>
      </article>
      <div className="home-hero"><span>露米在等你！</span><img src={assets.hero} alt="鹿屿森空探索师" /></div>
      <div className="home-doors">
        <Link to="/world" className="door-world"><b>探索世界</b><small>英语 · 逻辑 · 数感</small><em>›</em></Link>
        <Link to="/room" className="door-room"><b>我的小屋</b><small>露米 · 啊朵 · 公主房</small><em>›</em></Link>
        <Link to="/surprise" className="door-surprise"><b>今日小惊喜</b><small>扭蛋 · 信件 · 收藏</small><em>›</em></Link>
      </div>
    </section>
  );
}
